export default "__VITE_ASSET__CvjS8uWn__"